import "./BMOSkuApproval.scss";
import TextArea from "../../components/Form/TextArea/TextArea";
import InputBox from "../../components/Form/InputBox/InputBox";
import { useEffect, useState } from "react";
import { MotifButton, MotifErrorMessage } from "@ey-xd/motif-react";
import { useNavigate } from "react-router";
import {
  isNumeric,
  isStringHavingSpecialChars,
  ltrimString,
  requiredValidationForEditor,
  isPositiveValidation,
  isValidUrlWithWWW,
  requiredValidationForFields,
} from "../../utils/Validator";
import {
  APPROVE,
  MORE_INFORMATION,
  BMO_SKU_EDIT,
  CANCEL,
  COMMERCIAL_DESCRIPTION,
  COMMERCIAL_OWNER_NAME,
  COMMERCIAL_OWNER_PROXY_NAME,
  CT_PORTFOLIO,
  PRODUCT_RESOURCES,
  PRODUCT_RESOURCES_NO_ARTIFACTS,
  PRODUCT_RESOURCE_DOWNLOAD_LABEL,
  PRODUCT_RESOURCE_VISIT_LINK_LABEL,
  CT_PRODUCT_MANAGER,
  DEMAND_MANAGEMENT_TEAM_ID,
  DEMAND_MANAGEMENT_TEAM_ID_LABEL,
  DEMAND_MANAGEMENT_TEAM_ID_URL,
  DESCRIPTION,
  EMAIL_ID_PLACEHOLDER,
  EMPIRE_CODE,
  EMPIRE_CODE_PLACEHOLDER,
  GLOBAL_SERVICE_CODE,
  GLOBAL_SERVICE_CODE_PRIMARY_LIST,
  GLOBAL_SERVICE_CODE_SECONDARY_LIST,
  PRIMARY_LIST_PLACEHOLDER,
  PRODUCT_CONTACTS,
  PRODUCT_DESCRIPTION,
  PRODUCT_DETAILS_LABEL,
  PRODUCT_NAME,
  PRODUCT_SUPPORT_LINK,
  REJECT,
  SECONDARY_LIST_PLACEHOLDER,
  SUPPORT,
  SUPPORT_LINK,
  SUPPORT_LINK_NAME,
  TEAM_EMAIL_ID,
} from "./Constants";
import { MotifIcon } from "@ey-xd/motif-react";
import {
  MotifNavigationIcClose24px,
  IconoirCheck,
  IconoirArrowLeft,
  IconoirNotes,
  IconoirLink,
  IconoirDownload,
  IconoirOpenNewWindow,
} from "@ey-xd/motif-icon";
import NotificationGrid from "../../components/Notification/NotificationGrid";
import {
  PROVISIONING_TEAM,
  GLOBAL_NOTIFICATION,
  MAX_LENGTH,
  VALIDATION_ERROR_MESSAGES,
  FORM_LABEL_DESCRIPTION,
  RICH_TEXT_EDITOR_FIELD_NAMES,
} from "../../Constant";
import Loader from "../../components/Loader";
import { Link } from "react-router";
import Breadcrumb from "../../components/Breadcrumb";
import { useSelector, useDispatch } from "react-redux";

import { RootState, AppDispatch } from "../../store";
import { mapProductAPIDataWithFormFields, validateFormFields } from "./Helper";
import {
  fetchProductDetailsData,
  resetProductDetailState,
} from "../../store/slices/CTDBProductDetailsSlice";
import { fetchLatestSkuListData } from "../../store/slices/CTDBSkuListSlice";
import {
  fetchArtifactDetailsData,
  fetchArtifactFileData,
} from "../../store/slices/CTArtifactDetailsSlice";
import { useParams } from "react-router";
import MultiSelectUserSearch from "../../components/Form/MultiSelectUserSearch/MultiSelectUserSearch";
import { assignProxy } from "../../store/slices/CTDBAssignProxySlice";
import { RichTextEditor } from "../../components/Form/RichTextEditor/RichTextEditor";
import CreateSku from "./Components/CreateSku/CreateSku";
import { BILLING_TYPE_STATUS, INDEXATION, NSR } from "../CreateSku/Constants";
import ApproveSkuModal from "../../components/ApproveSkuModal";
import RejectSkuModal from "../../components/RejectSkuModal/RejectSkuModal";
import {
  reviewBmo,
  resetreviewBmoState,
} from "../../store/slices/CTDBBMOFormApprovalSlice";
import {
  mapBmoSKuDataWithApi,
  validatePercentageRange,
} from "../CreateSku/helper";
import InfoTooltip from "../../components/InfoTooltip";
import {
  validateMinimumSelectableIncrement,
  getMinimumSelectableIncrementErrorMessage,
} from "../../utils/Validator";
import {
  approveNewCost,
  resetCostUpdateState,
} from "../../store/slices/CTDBBMOCostUpdateSlice";
import {
  downloadBase64File,
  urlify,
  sanitizeHTMLSpace,
} from "../../utils/common";
import { fetchSkuConfigData } from "../../store/slices/CTDBSkuConfigSlice";
import EmailNotification from "../../components/EmailNotification";
import { EmailNotificationState } from "./ProductDataType";
import UserSearchSelect from "../../components/UserSearchSelect";
interface ProxyOwner {
  Name: string;
  Email: string;
}

interface ArtifactType {
  ProductArtifactId: string;
  ProductId: string;
  Title: string;
  Description: string | null;
  URL: string | null;
  ArtifactTypeCd: string;
  ArtifactCategoryCd: string;
}

const BMOSkuApproval = () => {
  const initialValues = {
    empireCode: "",
    productName: "",
    productDescription: "",
    commercialDescription: "",
    assetAdvice: "",
    ctPrortfolio: "",
    primaryList: "",
    secondryList: "",
    commercialOwnerName: "",
    commercialOwnerProxyName: "",
    ctTechnicalProductManager: "",
    managementTeamID: "",
    teamEmailID: "",
    productContact: "",
    productSupport: "",
    productSupportText: "",
  };

  const initialValuesSKU = {
    skuShortDescription: "",
    skuLongDescription: "",
    costCategory: "",
    chargingIncrement: "",
    returnable: "",
    costMacroCategory: "",
    minimumSelectableIncrement: "",
    cost: "",
    skuRelation: [],
    autoProvision: "",
    commercialStatus: "",
    costMetric: "",
    billingType: "",
    CostMetricNSR: "",
    Indexation: "",
    GlobalRiskMgr: [],
    LocalRiskMgr: [],
    ProductApprover: [],
    DeploymentApprover: [],
  };
  const [formFieldsSku, setFormFieldsSku] = useState<any>(initialValuesSKU);
  const [proxyOwners, setProxyOwners] = useState<ProxyOwner[] | null>([]);
  const [productContacts, setProductContacts] = useState<ProxyOwner[] | null>(
    [],
  );
  const [localRiskMng, setLocalRiskMng] = useState<ProxyOwner[] | null>([]);
  const [globalRiskMng, setGlobalRiskMng] = useState<ProxyOwner[] | null>(null);
  const [productApproverList, setProductApproverList] = useState<
    ProxyOwner[] | null
  >(null);
  const [deploymentApproverList, setDeploymentApproverList] = useState<
    ProxyOwner[] | null
  >(null);
  const [consumptionManagerList, setConsumptionManagerList] = useState<
    ProxyOwner[] | null
  >([]);

  const [showSkuApprovalModal, setShowSkuApprovalModal] = useState(false);
  const [showSkuRejectModal, setShowSkuRejectModal] = useState(false);
  const [rejectReasonApiError, setRejectReasonApiError] = useState("");
  const [resetSearch, setResetSearch] = useState(false);
  const [disableProductDetails, setDisableProductDetails] = useState(false);
  const [approveSKULoading, setApproveSKULoading] = useState(false);
  const [fileBackendError, setFileBackendError] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const param = useParams();

  const { id, skuID } = param;

  const isLoadingAPi = useSelector(
    (state: RootState) => state.CTDBProductDetailsSlice.isLoading,
  );
  const data = useSelector(
    (state: RootState) => state.CTDBProductDetailsSlice.data,
  );
  const errorAPi = useSelector(
    (state: RootState) => state.CTDBProductDetailsSlice.error,
  );
  const artifactData = useSelector(
    (state: RootState) => state.CTArtifactDetailsSlice.data,
  );
  const configData = useSelector(
    (state: RootState) => state.CTDBSkuConfigSlice.data,
  );

  const updateProductIsLoadingAPi = useSelector(
    (state: RootState) => state.CTDBUpdateProductSlice.isLoading,
  );
  const updateProductErrorAPi = useSelector(
    (state: RootState) => state.CTDBUpdateProductSlice.error,
  );
  const reviewProductErrorAPi = useSelector(
    (state: RootState) => state.CTDBBMOReviewSlice.error,
  );
  const approveSKUErrorApi = useSelector(
    (state: RootState) => state.CTDBBMOCostUpdateSlice.error,
  );
  const [formFields, setFormFields] = useState<{ [key: string]: string }>(
    initialValues,
  );

  const skuListData = useSelector(
    (state: RootState) => state.CTDBSkuListSlice.latestSkuList,
  );

  const filterSkuData = skuListData?.Result?.filter(
    (item: any) =>
      item.SkuId === skuID &&
      item.SkuRelation.length > 0 &&
      item.StatusCd === "sku_submitted",
  );

  const checkUpdateStatus = (filterSkuData: any) => {
    if (!filterSkuData || filterSkuData.length === 0) return true;

    const relationData = filterSkuData[0]?.SkuRelation;

    const childSkuIds = relationData.map((item: any) => item.ChildSkuId);

    const hasInactive = skuListData?.Result?.some(
      (ref) => childSkuIds.includes(ref.SkuId) && ref.StatusCd !== "sku_active",
    );

    return !hasInactive; // true if all are active
  };

  const isActiveAllChildSkus = checkUpdateStatus(filterSkuData);

  const [notificationVisible, setNotificationVisible] = useState({
    notificationVisible: false,
    message: "",
    type: "",
  });

  const [emailNotification, setEmailNotification] =
    useState<EmailNotificationState>({
      show: false,
      message: "",
      supportingText: "",
      type: "info",
      actionRedirectUrl: "",
      actionRedirectLabel: "",
      scrollToSection: "",
    });

  const resetErrors = () => {
    setError(errorInitail);
    setNotificationVisible({
      ...notificationVisible,
      notificationVisible: false,
      message: "",
      type: "",
    });
  };

  const clearRejectModalError = () => {
    if (rejectReasonApiError) {
      setRejectReasonApiError("");
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top on component mount
    dispatch(resetCostUpdateState());
  }, []);

  useEffect(() => {
    if (!showSkuRejectModal && reviewProductErrorAPi) {
      dispatch(resetreviewBmoState());
    }
  }, [dispatch, reviewProductErrorAPi, showSkuRejectModal]);

  useEffect(() => {
    if (data && data !== null && param.id !== data?.Data?.ProductId) {
      dispatch(resetProductDetailState());
    }
    if (id !== undefined) {
      dispatch(
        fetchProductDetailsData({
          productId: id,
        }),
      );
      dispatch(
        fetchLatestSkuListData({
          search: "",
          productId: id || "",
          page: 1,
          record: 1000,
          sortOrder: "desc",
          sortColumn: "SkuId",
        }),
      );
      dispatch(
        fetchArtifactDetailsData({
          productId: id,
        }),
      );
      dispatch(fetchSkuConfigData());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, skuID]);

  useEffect(() => {
    if (data !== null && data !== undefined) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const productFormData = mapProductAPIDataWithFormFields(data?.Data);
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      setFormFields(productFormData);
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      setProxyOwners(data?.Data?.ProxyOwner);
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      setProductContacts(data?.Data?.ProductContact);
    }
  }, [data]);

  const errorInitail = {
    empireCode: {
      isError: false,
      message: "",
      isDirty: false,
      label: EMPIRE_CODE,
      validation: ["required"],
      maxLengthLimit: 0,
    },
    productName: {
      isError: false,
      message: "",
      isDirty: false,
      label: PRODUCT_NAME,
      validation: ["required"],
      maxLengthLimit: 0,
    },
    commercialDescription: {
      isError: false,
      message: "",
      isDirty: false,
      label: COMMERCIAL_DESCRIPTION,
      validation: ["required", "maxLength"],
      maxLengthLimit: 0,
    },
    assetAdvice: {
      isError: false,
      message: "",
      isDirty: false,
      label: MORE_INFORMATION,
      validation: ["required", "maxLength"],
      maxLengthLimit: 0,
    },
    primaryList: {
      isError: false,
      message: "",
      isDirty: false,
      label: GLOBAL_SERVICE_CODE_PRIMARY_LIST,
      validation: ["isNumber"],
      maxLengthLimit: 0,
    },
    secondryList: {
      isError: false,
      message: "",
      isDirty: false,
      label: GLOBAL_SERVICE_CODE_SECONDARY_LIST,
      validation: ["isNumber"],
      maxLengthLimit: 0,
    },
    productSupport: {
      isError: false,
      message: "",
      isDirty: false,
      label: SUPPORT_LINK,
      validation: ["isUrl"],
      maxLengthLimit: 0,
    },
    productSupportText: {
      isError: false,
      message: "",
      isDirty: false,
      label: SUPPORT_LINK_NAME,
      validation: [""],
      maxLengthLimit: 80,
    },
  };

  const errorInitailSKU = {
    skuShortDescription: {
      isError: false,
      message: "",
      validation: ["required", "maxLength"],
      maxLengthLimit: 100,
    },
    skuLongDescription: {
      isError: false,
      message: "",
      validation: ["required", "maxLength"],
      maxLengthLimit: MAX_LENGTH,
    },
    costCategory: {
      isError: false,
      message: "",
      validation: ["required"],
    },
    chargingIncrement: {
      isError: false,
      message: "",
      validation: ["required"],
    },
    returnable: {
      isError: false,
      message: "",
      validation: ["required"],
    },
    costMacroCategory: {
      isError: false,
      message: "",
      validation: ["required"],
    },
    minimumSelectableIncrement: {
      isError: false,
      message: "",
      validation: ["required", "isInteger", "isNumber", "isPositive"],
    },
    cost: {
      isError: false,
      message: "",
      validation: ["required"],
    },
    skuRelation: {
      isError: false,
      message: "",
      validation: [""],
    },
    autoProvision: {
      isError: false,
      message: "",
      validation: ["required"],
    },
    commercialStatus: {
      isError: false,
      message: "",
      validation: ["required"],
    },
    billingType: {
      isError: false,
      message: "",
      validation: ["required"],
      label: BILLING_TYPE_STATUS,
    },
    Indexation: {
      isError: false,
      message: "",
      validation: ["validatePercentageRange"],
      label: INDEXATION,
    },
    costMetric: {
      isError: false,
      message: "",
      validation: ["required"],
    },
    CostMetricNSR: {
      isError: false,
      message: "",
      validation: [""],
      label: NSR,
    },
    deploymentApprover: {
      isError: false,
      message: "",
      validation: [""],
      label: PROVISIONING_TEAM,
    },
  };

  const [error, setError] = useState(errorInitail);
  const [errorSKU, setErrorSKU] = useState(errorInitailSKU);
  const {
    empireCode: empireCodeError,
    productName: productNameError,
    assetAdvice: assetAdviceError,
    primaryList: primaryListError,
    secondryList: secondryListError,
    productSupport: productSupportError,
    productSupportText: productSupportTextError,
  } = error;

  const checkMaxLength = (
    name: string,
    value: string,
    maxLengthLimit = MAX_LENGTH,
  ) => {
    if (value.length > maxLengthLimit) {
      setErrorSKU(() => {
        return {
          ...errorSKU,
          [name]: {
            isError: true,
            message: `Maximum length should be ${maxLengthLimit} characters`,
            validation:
              errorInitailSKU[name as keyof typeof errorInitailSKU].validation,
            maxLengthLimit: maxLengthLimit,
          },
        };
      });
      return value.substring(0, MAX_LENGTH);
    } else {
      setErrorSKU(() => {
        return {
          ...errorSKU,
          [name]: {
            isError: false,
            message: "",
            validation:
              errorInitailSKU[name as keyof typeof errorInitailSKU].validation,
          },
        };
      });
    }
    return value;
  };

  const validateFieldsSKU = (
    name: string,
    value: string | string[],
  ): boolean | undefined => {
    const validatorArray =
      errorInitailSKU &&
      errorInitailSKU[name as keyof typeof errorInitailSKU]?.validation;

    if (
      name === "skuNumber" ||
      name === "skuNumber_2" ||
      name === "skuNumber_3"
    ) {
      if (value === "" || value === undefined || value === null) {
        const requiredError = {
          isError: true,
          message: VALIDATION_ERROR_MESSAGES.REQUIRED,
          validation:
            errorInitailSKU[name as keyof typeof errorInitailSKU].validation,
        };
        const newError = {
          ...errorSKU,
          [name]: requiredError,
        };
        setErrorSKU(newError);
        return false;
      } else {
        setErrorSKU(() => {
          return {
            ...errorSKU,
            [name]: {
              isError: false,
              message: "",
              validation:
                errorInitailSKU[name as keyof typeof errorInitailSKU]
                  ?.validation,
            },
          };
        });
      }
    }

    if (validatorArray && validatorArray.includes("validatePercentageRange")) {
      const stringValue = Array.isArray(value) ? value.join("") : value;
      const indexationValue = stringValue.replace("%", "").trim();

      if (indexationValue === "") {
        setErrorSKU((prev) => ({
          ...prev,
          [name]: {
            isError: false,
            message: "",
            validation:
              errorInitailSKU[name as keyof typeof errorInitailSKU].validation,
          },
        }));
      } else if (!validatePercentageRange(indexationValue)) {
        setErrorSKU((prev) => ({
          ...prev,
          [name]: {
            isError: true,
            message: VALIDATION_ERROR_MESSAGES.PERCENTAGE_RANGE_ERROR,
            validation:
              errorInitailSKU[name as keyof typeof errorInitailSKU].validation,
          },
        }));
      } else {
        setErrorSKU((prev) => ({
          ...prev,
          [name]: {
            isError: false,
            message: "",
            validation:
              errorInitailSKU[name as keyof typeof errorInitailSKU].validation,
          },
        }));
      }
    }

    if (validatorArray && validatorArray.includes("required")) {
      let isValid = false;
      let hasHtml = false;
      if (RICH_TEXT_EDITOR_FIELD_NAMES.includes(name)) {
        isValid = requiredValidationForEditor(value);
      } else {
        ({ isValid, hasHtml } = requiredValidationForFields(value));
      }
      if (!isValid) {
        const requiredError = {
          isError: true,
          message: !hasHtml
            ? VALIDATION_ERROR_MESSAGES.REQUIRED
            : VALIDATION_ERROR_MESSAGES.INVALID_CHARACTERS,
          validation:
            errorInitailSKU[name as keyof typeof errorInitailSKU].validation,
        };
        const newError = {
          ...errorSKU,
          [name]: requiredError,
        };
        setErrorSKU(newError);
        return false;
      } else {
        setErrorSKU(() => {
          return {
            ...errorSKU,
            [name]: {
              isError: false,
              message: "",
              validation:
                errorInitailSKU[name as keyof typeof errorInitailSKU]
                  .validation,
            },
          };
        });
        //return true;
      }
    }

    if (
      validatorArray &&
      validatorArray.includes("maxLength") &&
      !Array.isArray(value)
    ) {
      const fieldError = errorInitailSKU[name as keyof typeof errorInitailSKU];
      let maxLengthLimit = MAX_LENGTH;
      if ("maxLengthLimit" in fieldError) {
        maxLengthLimit = fieldError.maxLengthLimit as number;
      }
      value = checkMaxLength(name, value, maxLengthLimit);
    }

    if (
      validatorArray &&
      validatorArray.includes("isNumber") &&
      !Array.isArray(value)
    ) {
      if (value === null || value === "" || isNumeric(value)) {
        setErrorSKU(() => {
          return {
            ...errorSKU,
            [name]: {
              isError: false,
              message: "",
              validation:
                errorInitailSKU[name as keyof typeof errorInitailSKU]
                  .validation,
            },
          };
        });
      } else {
        setErrorSKU(() => {
          return {
            ...errorSKU,
            [name]: {
              isError: true,
              message:
                VALIDATION_ERROR_MESSAGES.MINIMUM_SELECT_INCREMENT_INT_NUM,
              validation:
                errorInitailSKU[name as keyof typeof errorInitailSKU]
                  .validation,
            },
          };
        });
        return false;
      }
    }

    if (validatorArray && validatorArray.includes("isPositive")) {
      if (!isPositiveValidation(Number(value))) {
        const requiredError = {
          isError: true,
          message: VALIDATION_ERROR_MESSAGES.MINIMUM_SELECT_INCREMENT_INT_NUM,
          validation:
            errorInitailSKU[name as keyof typeof errorInitailSKU].validation,
        };
        const newError = {
          ...errorSKU,
          [name]: requiredError,
        };
        setErrorSKU(newError);
        return false;
      } else {
        setErrorSKU(() => {
          return {
            ...errorSKU,
            [name]: {
              isError: false,
              message: "",
              validation:
                errorInitailSKU[name as keyof typeof errorInitailSKU]
                  .validation,
            },
          };
        });
        //return true;
      }
    }

    if (
      validatorArray &&
      validatorArray.includes("isInteger") &&
      !Array.isArray(value)
    ) {
      if (value === null || value === "" || isInteger(value)) {
        setErrorSKU(() => {
          return {
            ...errorSKU,
            [name]: {
              isError: false,
              message: "",
              validation:
                errorInitailSKU[name as keyof typeof errorInitailSKU]
                  .validation,
            },
          };
        });
      } else {
        setErrorSKU(() => {
          return {
            ...errorSKU,
            [name]: {
              isError: true,
              message:
                VALIDATION_ERROR_MESSAGES.MINIMUM_SELECT_INCREMENT_INT_NUM,
              validation:
                errorInitailSKU[name as keyof typeof errorInitailSKU]
                  .validation,
            },
          };
        });
        return false;
      }
    }

    if (
      name === "minimumSelectableIncrement" &&
      validatorArray &&
      !Array.isArray(value)
    ) {
      const chargingIncrement = formFieldsSku.chargingIncrement;
      const numValue = Number(value);

      if (
        value &&
        (chargingIncrement === "week" || chargingIncrement === "month")
      ) {
        const isValidIncrement = validateMinimumSelectableIncrement(
          numValue,
          chargingIncrement,
        );

        if (!isValidIncrement) {
          setErrorSKU((prev) => ({
            ...prev,
            [name]: {
              isError: true,
              message:
                getMinimumSelectableIncrementErrorMessage(chargingIncrement),
              validation: validatorArray,
            },
          }));
          return false;
        }
      }
    }
    return true;
  };

  const isInteger = (x: number | string): boolean => {
    if (typeof x === "string") {
      if (x === "") {
        return false; // Empty string is not an integer
      }
      if (!/^\d+$/.test(x.toString())) {
        return false; // Not a number
      }
      x = parseFloat(x); // Convert string to number
    }
    return Math.round(x) === x;
  };

  const isValidForm = async () => {
    let isValid = true;
    for (const [key, value] of Object.entries(formFields)) {
      const isNotValidField = validateFormFields(key, value, error, setError);
      if (isNotValidField) {
        isValid = false;
      }
    }
    let isValidSKU = true;
    for (const [key, value] of Object.entries(formFieldsSku)) {
      if (!validateFieldsSKU(key, value as string)) {
        isValidSKU = false;
        return isValidSKU;
      }
    }
    if (!isValidSKU || !isValid) {
      return false;
    }
    return isValid;
  };

  const isDisplayNameValid = (value: string) => {
    // Allows letters, numbers, spaces, hyphens, underscores, periods, commas, apostrophes, parentheses
    return /^[\w\s\-.,'()]+$/.test(value);
  };

  const handleChange = (event: { target: { name: string; value: string } }) => {
    const { name, value } = event.target;
    let val = ltrimString(value);

    if (name === "productSupportText") {
      let errorMsg = "";
      if (val.length > 80) {
        errorMsg = "The Name must be 80 characters or fewer.";
      } else if (val && !isDisplayNameValid(val)) {
        errorMsg =
          "The Name can only contain letters, numbers, spaces, hyphens, underscores, periods, commas, apostrophes, and parentheses.";
      }
      setError((prev) => ({
        ...prev,
        productSupportText: {
          ...prev.productSupportText,
          isError: !!errorMsg,
          message: errorMsg,
        },
      }));
    }
    if (
      isStringHavingSpecialChars(val) &&
      name !== "productSupport" &&
      name !== "commercialDescription" &&
      name !== "assetAdvice" &&
      name !== "productSupportText"
    ) {
      return;
    }

    if (name == "productSupport") {
      val = normalizeUrl(value);
    }
    setFormFields(() => {
      return {
        ...formFields,
        [name]: val,
      };
    });
    validateFormFields(name, val, error, setError);
  };

  const normalizeUrl = (url: string) => {
    // Check if protocol exists
    const hasProtocol = /^https?:\/\//i.test(url);

    if (hasProtocol) {
      // Lowercase protocol + domain only
      return url.replace(/^([a-z]+):\/\/([^\/]+)/i, (_, protocol, domain) => {
        return protocol.toLowerCase() + "://" + domain.toLowerCase();
      });
    } else {
      // No protocol → lowercase domain only (before first slash)
      return url.replace(/^([^\/]+)/, (domain) => domain.toLowerCase());
    }
  };

  const handleBlur = (event: { target: { name: string; value: string } }) => {
    const { name, value } = event.target;
    let val = normalizeUrl(ltrimString(value));
    const urlRegex = /^https?:\/\//i;
    if (val && isValidUrlWithWWW(value) && !urlRegex.test(val)) {
      val = "https://" + val;
      setFormFields(() => {
        return {
          ...formFields,
          [name]: val,
        };
      });
      validateFormFields(name, val, error, setError);
    }
  };

  const isErrorExists = () => {
    let isErrorExist = false;
    for (const errorField in error) {
      if (error[errorField as keyof typeof error]["isError"])
        isErrorExist = true;
    }
    for (const errorField in errorSKU) {
      if (errorSKU[errorField as keyof typeof errorSKU]["isError"])
        isErrorExist = true;
    }

    if (
      formFieldsSku.autoProvision === "0" &&
      deploymentApproverList?.length === 0
    ) {
      isErrorExist = true;
    }

    return isErrorExist;
  };

  const handleSaveApproval = async (action?: string, file?: File) => {
    resetErrors();
    setResetSearch(false);
    const validFormStatus = await isValidForm();
    let isErrorExist = false;
    for (const errorField in error) {
      if (error[errorField as keyof typeof error]["isError"])
        isErrorExist = true;
    }
    for (const errorField in errorSKU) {
      if (errorSKU[errorField as keyof typeof errorSKU]["isError"])
        isErrorExist = true;
    }
    if (!validFormStatus || isErrorExist) {
      setNotificationVisible({
        ...notificationVisible,
        notificationVisible: true,
        message: GLOBAL_NOTIFICATION.UNEXPECTED_ERROR,
        type: "error",
      });
      setShowSkuRejectModal(false);
      setShowSkuApprovalModal(false);
      return false;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const removeObjectKeys = (obj: any) => {
      if (obj === null || obj === undefined) {
        return obj;
      }
      if ("EntityId" in obj && "RoleCd" in obj) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { EntityId, RoleCd, ...filterObj } = obj;
        return filterObj;
      }
      return obj;
    };

    setResetSearch(true);
    const productContact = productContacts?.map(removeObjectKeys);
    const GlobalRiskMgr = globalRiskMng;

    const LocalRiskMgr = localRiskMng;
    const ProductApprover = productApproverList;
    const DeploymentApprover = deploymentApproverList;
    const commercialOwnerProxyName = proxyOwners ? proxyOwners : null;

    const {
      empireCode,
      commercialDescription,
      assetAdvice,
      primaryList,
      secondryList,
      productSupport,
      productSupportText,
    } = formFields;
    const approvalFormData = {
      ProductId: empireCode,
      CommercialDescription: commercialDescription,
      AssetAdvice: assetAdvice,
      GlobalServiceCodesPrimary: primaryList,
      GlobalServiceCodesSecondary: secondryList,
      ProductContact: productContact || [],
      ProductSupport: productSupport || "",
      ProductSupportText: productSupportText || "",
      Action: BMO_SKU_EDIT,
      SkuId: skuID,
      StatusCd: "sku_active",
    };
    const updatedFormFieldsSku = {
      ...formFieldsSku,
      GlobalRiskMgr: GlobalRiskMgr,
      LocalRiskMgr: LocalRiskMgr,
      ProductApprover: ProductApprover,
      DeploymentApprover: DeploymentApprover,
      ConsumptionMgr: consumptionManagerList,
    };
    const finalPayload = {
      ...approvalFormData,
      ...mapBmoSKuDataWithApi(updatedFormFieldsSku),
      Indexation: isNumeric(formFieldsSku.Indexation)
        ? parseFloat(formFieldsSku.Indexation)
        : null,
      CostMetricNSR: formFieldsSku.CostMetricNSR
        ? formFieldsSku.CostMetricNSR
        : null,
    };
    try {
      setApproveSKULoading(true);
      const approveResponse = await dispatch(
        approveNewCost({
          Action: action || "",
          SkuId: skuID || "",
          UpdateCost: null,
          UpdateNSR: null,
          UpdateIndexation: null,
          UpdatePublishdtm: "",
          file,
        }),
      );
      if (approveResponse.payload.Status === "success") {
        try {
          const response = await dispatch(
            reviewBmo(action === BMO_SKU_EDIT || finalPayload),
          );

          if (response.payload.Status === "success") {
            setApproveSKULoading(false);
            navigate("/ct/bmo");

            try {
              const response = await dispatch(
                assignProxy({
                  productId: empireCode,
                  proxyOwners: commercialOwnerProxyName
                    ? commercialOwnerProxyName
                    : [],
                }),
              );
              if (response.payload.Status === "success") {
                setApproveSKULoading(false);
                setNotificationVisible({
                  ...notificationVisible,
                  notificationVisible: true,
                  message: GLOBAL_NOTIFICATION.UPDATED_SUCCESSFULLY,
                  type: "success",
                });
                setShowSkuApprovalModal(false);
              }
              // Add any additional logic here if needed
            } catch (error) {
              setApproveSKULoading(false);
              console.log("Error in update proxy owners", error);
              setNotificationVisible({
                ...notificationVisible,
                notificationVisible: true,
                message: GLOBAL_NOTIFICATION.UNEXPECTED_ERROR,
                type: "error",
              });
              setShowSkuApprovalModal(false);
            }
          } else {
            setApproveSKULoading(false);
            setNotificationVisible({
              ...notificationVisible,
              notificationVisible: true,
              message:
                response.payload.message ||
                GLOBAL_NOTIFICATION.UNEXPECTED_ERROR,
              type: "error",
            });
            setShowSkuApprovalModal(false);
          }
          // Add any additional logic here if needed
        } catch (error) {
          console.log("Error in update Product", error);
          setApproveSKULoading(false);
          setNotificationVisible({
            ...notificationVisible,
            notificationVisible: true,
            message: GLOBAL_NOTIFICATION.UNEXPECTED_ERROR,
            type: "error",
          });
          setShowSkuApprovalModal(false);
        }
      } else if (approveResponse?.payload?.message === "Invalid file") {
        setApproveSKULoading(false);
        dispatch(resetCostUpdateState());
        setFileBackendError(true);
      } else {
        setApproveSKULoading(false);
        setShowSkuApprovalModal(false);
        setNotificationVisible({
          ...notificationVisible,
          notificationVisible: true,
          message:
            approveResponse?.payload?.message ||
            GLOBAL_NOTIFICATION.UNEXPECTED_ERROR,
          type: "error",
        });
      }
    } catch (error) {
      console.log("Error in approve SKU", error);
      setApproveSKULoading(false);
      setShowSkuApprovalModal(false);
      setNotificationVisible({
        ...notificationVisible,
        notificationVisible: true,
        message: GLOBAL_NOTIFICATION.UNEXPECTED_ERROR,
        type: "error",
      });
    }
  };

  const handleRejectHandler = async (action?: string, msg?: string) => {
    clearRejectModalError();
    if (reviewProductErrorAPi) {
      dispatch(resetreviewBmoState());
    }
    const commercialOwnerProxyName = proxyOwners ? proxyOwners : null;
    const rejectFormData = {
      Action: action,
      Message: msg,
      SkuId: skuID,
    };
    try {
      const response = await dispatch(reviewBmo(rejectFormData));
      if (response.payload.Status === "success") {
        setRejectReasonApiError("");
        navigate("/ct/bmo");

        try {
          const response = await dispatch(
            assignProxy({
              productId: empireCode,
              proxyOwners: commercialOwnerProxyName
                ? commercialOwnerProxyName
                : [],
            }),
          );
          if (response.payload.Status === "success") {
            setNotificationVisible({
              ...notificationVisible,
              notificationVisible: true,
              message: GLOBAL_NOTIFICATION.UPDATED_SUCCESSFULLY,
              type: "success",
            });
            setShowSkuRejectModal(false);
          }
          // Add any additional logic here if needed
        } catch (error) {
          console.log("Error in update proxy owners", error);
          setNotificationVisible({
            ...notificationVisible,
            notificationVisible: true,
            message: GLOBAL_NOTIFICATION.UNEXPECTED_ERROR,
            type: "error",
          });
          setShowSkuRejectModal(false);
        }
      } else {
        setRejectReasonApiError(
          response.payload.message || GLOBAL_NOTIFICATION.UNEXPECTED_ERROR,
        );
      }
      // Add any additional logic here if needed
    } catch (error) {
      console.log("Error in reject SKU", error);
      setRejectReasonApiError(GLOBAL_NOTIFICATION.UNEXPECTED_ERROR);
    }
  };

  const handleArtifactAction = async (item: ArtifactType) => {
    if (item.ArtifactTypeCd === "prodarttype_doc") {
      const fileData = await dispatch(
        fetchArtifactFileData({
          productId: item.ProductId,
          productArtifactId: item.ProductArtifactId,
        }),
      );
      if (fileData && fileData.payload.Status === "success") {
        downloadBase64File(
          fileData.payload.Data.fileContent,
          fileData.payload.Data.fileName,
          fileData.payload.Data.contentType,
        );
      }
      return;
    }

    if (item.ArtifactTypeCd === "prodarttype_link" && item.URL) {
      window.open(urlify(item.URL), "_blank", "noopener,noreferrer");
    }
  };

  const {
    empireCode,
    productDescription,
    assetAdvice,
    commercialDescription,
    ctPrortfolio,
    primaryList,
    secondryList,
    commercialOwnerName,
    ctTechnicalProductManager,
    productSupport,
    teamEmailID,
    productName,
    productSupportText,
  } = formFields;
  const breadcrumbItems = [
    {
      label: "External Submission",
      value: "bmo",
      elementKey: "submission",
      text: "BMO",
      url: `/ct/bmo`,
      icon: <MotifIcon src={IconoirArrowLeft} />,
    },
    {
      label: "External Submission",
      value: formFieldsSku?.skuShortDescription || "",
      elementKey: "submission",
      text: formFieldsSku?.skuShortDescription || "", // Ensure text is always a string
      url: `/bmo`,
      icon: <MotifIcon src={IconoirArrowLeft} />,
      disabled: true,
    },
  ];
  return (
    <>
      <div className="BMOSkuApproval">
        <div className="motif-row no-gutter">
          <div className="motif-col-lg-12 main-content-header">
            <div className="motif-container bmo-approval-header">
              <div className="motif-row">
                <div className="motif-col-lg-12">
                  <div className="bmo-approval-bredcrumb">
                    <Breadcrumb
                      items={breadcrumbItems}
                      ariaLabel="Breadcrumb navigation"
                    />
                  </div>
                </div>
              </div>
              <div className="motif-row">
                <div className="motif-col-lg-12">
                  <h1 className="header-tile">
                    {formFieldsSku?.skuShortDescription || ""}
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="main-content">
          {isLoadingAPi && (
            <div className="motif-row mar-b-20">
              <div className="motif-col-lg-12">
                <Loader />
              </div>
            </div>
          )}

          {notificationVisible?.notificationVisible &&
            notificationVisible?.type === "success" && (
              <div className="motif-row mar-b-20">
                <div className="motif-col-lg-12">
                  <NotificationGrid
                    show={notificationVisible?.notificationVisible}
                    message={GLOBAL_NOTIFICATION.UPDATED_SUCCESSFULLY}
                    type="success"
                  />
                </div>
              </div>
            )}
          {/* error for APi failure*/}
          {emailNotification.show && (
            <div className="motif-row mar-b-20">
              <div className="motif-col-lg-12">
                <EmailNotification
                  show={emailNotification.show}
                  message={emailNotification.message}
                  supportingText={emailNotification.supportingText}
                  type="info"
                  actionRedirectUrl={emailNotification.actionRedirectUrl}
                  hideCloseBtn={true}
                  actionRedirectLabel={emailNotification.actionRedirectLabel}
                  scrollToSection={emailNotification.scrollToSection}
                />
              </div>
            </div>
          )}
          {(errorAPi || updateProductErrorAPi || approveSKUErrorApi) && (
            <div className="motif-row mar-b-20">
              <div className="motif-col-lg-12">
                <NotificationGrid
                  show={errorAPi !== undefined}
                  message={GLOBAL_NOTIFICATION.UNEXPECTED_ERROR}
                  type="error"
                />
              </div>
            </div>
          )}

          {reviewProductErrorAPi && !showSkuRejectModal && (
            <div className="motif-row mar-b-20">
              <div className="motif-col-lg-12">
                <NotificationGrid
                  show={true}
                  message={reviewProductErrorAPi}
                  type="error"
                />
              </div>
            </div>
          )}

          {notificationVisible?.notificationVisible &&
            notificationVisible?.type === "error" &&
            !reviewProductErrorAPi &&
            !errorAPi &&
            !updateProductErrorAPi &&
            !approveSKUErrorApi &&
            !fileBackendError && (
              <div className="motif-row mar-b-20">
                <div className="motif-col-lg-12">
                  <NotificationGrid
                    show={notificationVisible?.notificationVisible}
                    message={GLOBAL_NOTIFICATION.INVALID_FORM}
                    type="error"
                  />
                </div>
              </div>
            )}
          <div className="motif-row heading">
            <div className="motif-col-lg-12">
              <div className="title">{PRODUCT_DETAILS_LABEL}</div>
            </div>
          </div>

          <div className="motif-row form-item-row double-row">
            <div className="motif-col-lg">
              <div className="motif-row">
                <div className="motif-col-lg-4 form-item label-item">
                  <div className="label">{EMPIRE_CODE}</div>
                </div>
                <div className="motif-col-lg-8 form-item">
                  <div className="value">
                    <div className="inputField">
                      <InputBox
                        ariaLabel=""
                        label=""
                        onChange={handleChange}
                        onBlur={handleBlur}
                        name={"empireCode"}
                        value={empireCode}
                        placeholder={EMPIRE_CODE_PLACEHOLDER}
                        error={empireCodeError}
                        readonly={true}
                        hideClearButton={true}
                      />
                      <MotifErrorMessage
                        aria-live="assertive"
                        role="alert"
                        id="aria-error-example"
                      >
                        {empireCodeError ? empireCodeError.message : ""}
                      </MotifErrorMessage>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="motif-col-lg">
              <div className="motif-row right-content">
                <div className="motif-col-lg-4 form-item label-item">
                  <div className="label">{PRODUCT_NAME}</div>
                </div>
                <div className="motif-col-lg-8 form-item">
                  <div className="value">
                    <div className="inputField">
                      <InputBox
                        ariaLabel=""
                        label=""
                        onChange={handleChange}
                        name={"productName"}
                        value={productName}
                        placeholder={PRODUCT_NAME}
                        readonly={true}
                        hideClearButton={true}
                      />
                      <MotifErrorMessage
                        aria-live="assertive"
                        role="alert"
                        id="aria-error-example"
                      >
                        {productNameError ? productNameError.message : ""}
                      </MotifErrorMessage>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="motif-row form-item-row single-row">
            <div className="motif-col-lg-2  form-item label-item">
              <div className="label">{PRODUCT_DESCRIPTION}</div>
              <InfoTooltip
                description={FORM_LABEL_DESCRIPTION.PRODUCT_DESCRIPTION}
                id={PRODUCT_DESCRIPTION}
              />
            </div>
            <div className="motif-col-lg-10  form-item">
              <div className="value">
                <div className="inputField">
                  <TextArea
                    ariaLabel=""
                    label=""
                    name={"productDescription"}
                    readonly={true}
                    hideClearButton={true}
                    value={productDescription}
                    placeholder={DESCRIPTION}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="motif-row form-item-row single-row">
            <div className="motif-col-lg-2 form-item label-item">
              <div className="label">
                {COMMERCIAL_DESCRIPTION}
                <span className="required">*</span>:
                <InfoTooltip
                  description={FORM_LABEL_DESCRIPTION.COMMERCIAL_DESCRIPTION}
                  id={COMMERCIAL_DESCRIPTION}
                />
              </div>
            </div>
            <div className="motif-col-lg-10 form-item">
              <RichTextEditor
                name={"commercialDescription"}
                placeholder={"Description"}
                value={
                  disableProductDetails
                    ? sanitizeHTMLSpace(commercialDescription)
                    : commercialDescription
                }
                handleChange={handleChange}
                readOnly={disableProductDetails}
              />
              <MotifErrorMessage
                aria-live="assertive"
                role="alert"
                id="aria-error-example"
              >
                {error?.commercialDescription?.isError
                  ? error?.commercialDescription?.message
                  : ""}
              </MotifErrorMessage>
            </div>
          </div>
          <div className="motif-row form-item-row single-row">
            <div className="motif-col-lg-2 form-item label-item">
              <div className="label">
                {MORE_INFORMATION}
                <span className="required">*</span>:
                <InfoTooltip
                  description={FORM_LABEL_DESCRIPTION.MORE_INFORMATION}
                  id={MORE_INFORMATION}
                />
              </div>
            </div>
            <div className="motif-col-lg-10 form-item">
              <RichTextEditor
                name={"assetAdvice"}
                placeholder={"Description"}
                value={
                  disableProductDetails
                    ? sanitizeHTMLSpace(assetAdvice)
                    : assetAdvice
                }
                handleChange={handleChange}
                readOnly={disableProductDetails}
              />
              <MotifErrorMessage
                aria-live="assertive"
                role="alert"
                id="aria-error-example"
              >
                {assetAdviceError ? assetAdviceError.message : ""}
              </MotifErrorMessage>
            </div>
          </div>
          <div className="motif-row form-item-row single-row">
            <div className="motif-col-lg-2 form-item label-item">
              <div className="label">{CT_PORTFOLIO}</div>
              <InfoTooltip
                description={FORM_LABEL_DESCRIPTION.CT_PORTFOLIO}
                id={CT_PORTFOLIO}
              />
            </div>
            <div className="motif-col-lg-10 form-item">
              <div className="value">
                <InputBox
                  name={"ctPrortfolio"}
                  ariaLabel=""
                  label=""
                  onChange={handleChange}
                  placeholder={DESCRIPTION}
                  value={ctPrortfolio}
                  readonly={disableProductDetails || true}
                  hideClearButton={true}
                />
              </div>
            </div>
          </div>
          {artifactData && artifactData.Data && (
            <>
              <div className="motif-row heading">
                <div className="motif-col-lg-12">
                  <div className="title">{PRODUCT_RESOURCES}</div>
                </div>
              </div>
              {artifactData.Data.length > 0 ? (
                <div className="motif-row product-resources-list">
                  {artifactData.Data.map((item: ArtifactType) => (
                    <div
                      className="product-resource-card"
                      key={item.ProductArtifactId}
                    >
                      <div className="left">
                        <div className="icon-wrapper">
                          <MotifIcon
                            size="20"
                            iconFunction={
                              item.ArtifactTypeCd === "prodarttype_doc"
                                ? IconoirNotes
                                : IconoirLink
                            }
                          />
                        </div>
                      </div>
                      <div className="right">
                        <div className="resource-content">
                          <div className="resource-title">{item.Title}</div>
                          <div className="resource-category">
                            {configData?.CommercialStatus?.filter(
                              (category) =>
                                category.StatusType === "prodartcatg" &&
                                category.StatusCd === item.ArtifactCategoryCd,
                            ).map((category) => category.Name)}
                          </div>
                          <div className="resource-description">
                            {item.Description}
                          </div>
                        </div>
                        <div className="resource-actions">
                          <button
                            type="button"
                            className="resource-action-with-label"
                            onClick={() => handleArtifactAction(item)}
                            aria-label={
                              item.ArtifactTypeCd === "prodarttype_doc"
                                ? "Download Resource"
                                : "Open Link"
                            }
                          >
                            <span className="resource-action-text">
                              {item.ArtifactTypeCd === "prodarttype_doc"
                                ? PRODUCT_RESOURCE_DOWNLOAD_LABEL
                                : PRODUCT_RESOURCE_VISIT_LINK_LABEL}
                            </span>
                            <MotifIcon
                              size="20"
                              iconFunction={
                                item.ArtifactTypeCd === "prodarttype_doc"
                                  ? IconoirDownload
                                  : IconoirOpenNewWindow
                              }
                              className="resource-action-icon"
                            />
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="motif-row no-artifacts-message">
                  <div className="motif-col-lg-12">
                    {PRODUCT_RESOURCES_NO_ARTIFACTS}
                  </div>
                </div>
              )}
            </>
          )}
          <div className="motif-row heading">
            <div className="motif-col-lg-12">
              <div className="title">{GLOBAL_SERVICE_CODE}</div>
            </div>
          </div>
          <div className="motif-row form-item-row double-row">
            <div className="motif-col-lg">
              <div className="motif-row">
                <div className="motif-col-lg-4 form-item label-item">
                  <div className="label">
                    {GLOBAL_SERVICE_CODE_PRIMARY_LIST}
                  </div>
                </div>
                <div className="motif-col-lg-8 form-item">
                  <div className="value">
                    <div className="inputField">
                      <InputBox
                        ariaLabel=""
                        name={"primaryList"}
                        label=""
                        onChange={handleChange}
                        hideClearButton={true}
                        value={primaryList}
                        error={primaryListError}
                        placeholder={PRIMARY_LIST_PLACEHOLDER}
                        readonly={disableProductDetails}
                      />
                      {primaryListError ? (
                        <MotifErrorMessage
                          aria-live="assertive"
                          role="alert"
                          id="aria-error-primaryList"
                        >
                          {primaryListError.message}
                        </MotifErrorMessage>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="motif-col-lg">
              <div className="motif-row right-content">
                <div className="motif-col-lg-4 form-item label-item">
                  <div className="label">
                    {GLOBAL_SERVICE_CODE_SECONDARY_LIST}
                  </div>
                </div>
                <div className="motif-col-lg-8 form-item">
                  <div className="value">
                    <div className="inputField">
                      <InputBox
                        name={"secondryList"}
                        ariaLabel=""
                        label=""
                        onChange={handleChange}
                        value={secondryList}
                        hideClearButton={true}
                        error={secondryListError}
                        placeholder={SECONDARY_LIST_PLACEHOLDER}
                        readonly={disableProductDetails}
                      />
                      {secondryListError ? (
                        <MotifErrorMessage
                          aria-live="assertive"
                          role="alert"
                          id="aria-error-primaryList"
                        >
                          {secondryListError.message}
                        </MotifErrorMessage>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="motif-row heading">
            <div className="motif-col-lg-12">
              <div className="title">{PRODUCT_CONTACTS}</div>
            </div>
          </div>
          {/*split the row into two columns*/}
          <div className="motif-row form-item-row double-row">
            <div className="motif-col-lg">
              <div className="motif-row">
                <div className="motif-col-lg-4 form-item label-item">
                  <div className="label">{COMMERCIAL_OWNER_NAME}</div>
                </div>
                <div className="motif-col-lg-8 form-item">
                  <div className="value">
                    <div className={`inputField`}>
                      <InputBox
                        ariaLabel=""
                        label=""
                        name={"commercialOwnerName"}
                        onChange={handleChange}
                        value={commercialOwnerName}
                        placeholder={EMAIL_ID_PLACEHOLDER}
                        readonly={disableProductDetails || false}
                        hideClearButton={true}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="motif-col-lg">
              <div className="motif-row right-content">
                <div className="motif-col-lg-4 form-item label-item">
                  <div className="label">{COMMERCIAL_OWNER_PROXY_NAME}</div>
                </div>
                <div className="motif-col-lg-8 form-item">
                  <div className="value">
                    <div className={`inputField`}>
                      <MultiSelectUserSearch
                        proxyOwners={proxyOwners}
                        readOnly={disableProductDetails || false}
                        setProxyOwners={setProxyOwners}
                        resetSearch={resetSearch}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="motif-row form-item-row single-row">
            <div className="motif-col-lg-2 form-item label-item">
              <div className="label">{CT_PRODUCT_MANAGER}</div>
            </div>
            <div className="motif-col-lg-10 form-item">
              <div className="value">
                <div className="inputField">
                  <InputBox
                    ariaLabel=""
                    name={"ctTechnicalProductManager"}
                    label=""
                    onChange={handleChange}
                    value={ctTechnicalProductManager}
                    placeholder={EMAIL_ID_PLACEHOLDER}
                    readonly={disableProductDetails || false}
                    hideClearButton={true}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="motif-row heading">
            <div className=" motif-col-lg-12">
              <div className="title">{SUPPORT}</div>
            </div>
          </div>
          <div className="motif-row form-item-row double-row">
            <div className="motif-col-lg">
              <div className="motif-row">
                <div className="motif-col-lg-4 form-item label-item">
                  <div className="label">{DEMAND_MANAGEMENT_TEAM_ID}</div>
                </div>
                <div className="motif-col-lg-8 form-item">
                  <div className="value">
                    <div className="inputField">
                      <Link className="link" to={DEMAND_MANAGEMENT_TEAM_ID_URL}>
                        {DEMAND_MANAGEMENT_TEAM_ID_LABEL}
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="motif-col-lg">
              <div className="motif-row right-content">
                <div className="motif-col-lg-4 form-item label-item">
                  <div className="label">{TEAM_EMAIL_ID}</div>
                </div>
                <div className="motif-col-lg-8 form-item">
                  <div className="value">
                    <div className="inputField">
                      <InputBox
                        ariaLabel=""
                        name={"teamEmailID"}
                        label=""
                        onChange={handleChange}
                        value={teamEmailID}
                        readonly={disableProductDetails || false}
                        hideClearButton={true}
                        placeholder={EMAIL_ID_PLACEHOLDER}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="motif-row form-item-row double-row">
            <div className="motif-col-lg">
              <div className="motif-row">
                <div className="motif-col-lg-4 form-item label-item">
                  <div className="label">{PRODUCT_CONTACTS}</div>
                </div>
                <div className="motif-col-lg-8 form-item">
                  <div className="value">
                    <div className="inputField">
                      <UserSearchSelect
                        proxyOwners={productContacts}
                        setUserSearchSelect={setProductContacts}
                        name={"productContactInBMO"}
                        readOnly={disableProductDetails}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="motif-col-lg">
              <div className="motif-row right-content">
                <div className="motif-col-lg-4 form-item label-item">
                  <div className="label">{SUPPORT_LINK}</div>
                </div>
                <div className="motif-col-lg-8 form-item">
                  <div className="value">
                    <div className="inputField">
                      <InputBox
                        ariaLabel=""
                        label=""
                        onChange={handleChange}
                        onBlur={handleBlur}
                        name={"productSupport"}
                        value={productSupport}
                        readonly={disableProductDetails || false}
                        hideClearButton={true}
                        placeholder={PRODUCT_SUPPORT_LINK}
                        error={productSupportError}
                      />
                      {productSupportError ? (
                        <MotifErrorMessage
                          aria-live="assertive"
                          role="alert"
                          id="aria-error-primaryList"
                        >
                          {productSupportError.message}
                        </MotifErrorMessage>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="motif-row form-item-row double-row">
            <div className="motif-col-lg"></div>
            <div className="motif-col-lg">
              <div className="motif-row right-content">
                <div className="motif-col-lg-4 form-item label-item">
                  <div className="label">{SUPPORT_LINK_NAME}</div>
                </div>
                <div className="motif-col-lg-8 form-item">
                  <div className="value">
                    <div className="inputField">
                      <InputBox
                        ariaLabel=""
                        label=""
                        onChange={handleChange}
                        name={"productSupportText"}
                        value={productSupportText}
                        readonly={disableProductDetails || false}
                        hideClearButton={true}
                        placeholder={SUPPORT_LINK_NAME}
                        error={productSupportTextError}
                      />
                      {productSupportTextError ? (
                        <MotifErrorMessage
                          aria-live="assertive"
                          role="alert"
                          id="aria-error-primaryList"
                        >
                          {productSupportTextError.message}
                        </MotifErrorMessage>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="motif-row no-gutter headingCreateSKUError"></div>
          <CreateSku
            selectedSku={skuID}
            formFields={formFieldsSku}
            setFormFields={setFormFieldsSku}
            error={errorSKU}
            setError={setErrorSKU}
            validateFields={validateFieldsSKU}
            errorInitail={errorInitailSKU}
            localRiskMng={localRiskMng}
            setLocalRiskMng={setLocalRiskMng}
            globalRiskMng={globalRiskMng}
            setGlobalRiskMng={setGlobalRiskMng}
            productApproverList={productApproverList}
            setProductApproverList={setProductApproverList}
            deploymentApproverList={deploymentApproverList}
            setDeploymentApproverList={setDeploymentApproverList}
            consumptionManagerList={consumptionManagerList}
            setConsumptionManagerList={setConsumptionManagerList}
            setDisableProductDetails={setDisableProductDetails}
            emailNotification={emailNotification}
            setEmailNotification={setEmailNotification}
          />
        </div>
      </div>
      <div
        className={`motif-container btnContainer no-gutter ${disableProductDetails ? "hide" : ""}`}
      >
        <div className="motif-row btn-row no-gutter">
          <div className="motif-col-lg-8"></div>
          <div className="motif-col-lg-4">
            <div className="btnToolBar">
              <MotifButton
                size="small"
                type="button"
                variant="secondary"
                className="cancelButton"
                onClick={() => {
                  navigate("/ct/bmo");
                }}
                loading={false}
                disabled={disableProductDetails || updateProductIsLoadingAPi}
              >
                {CANCEL}
              </MotifButton>
              <MotifButton
                size="small"
                type="button"
                variant="primary"
                className="rejectButton"
                onClick={() => {
                  setShowSkuRejectModal(true);
                }}
                loading={false}
                disabled={disableProductDetails || updateProductIsLoadingAPi}
              >
                {
                  <MotifIcon
                    iconFunction={MotifNavigationIcClose24px}
                    title="Reject"
                    size="24"
                    fill="white"
                  />
                }{" "}
                {REJECT}
              </MotifButton>
              <MotifButton
                size="small"
                type="submit"
                variant="primary"
                className="approveButton"
                onClick={() => {
                  setShowSkuApprovalModal(true);
                }}
                disabled={
                  disableProductDetails ||
                  isActiveAllChildSkus === false ||
                  formFieldsSku?.commercialStatus !== "sku_submitted" ||
                  isErrorExists()
                }
              >
                {
                  <MotifIcon
                    fill="#fff"
                    stroke="#fff"
                    iconFunction={IconoirCheck}
                    title="Computer"
                    size="24"
                  />
                }{" "}
                {APPROVE}
              </MotifButton>
            </div>
          </div>
        </div>
      </div>
      <ApproveSkuModal
        show={showSkuApprovalModal}
        setShow={setShowSkuApprovalModal}
        selectedSku={skuID}
        btnLabel="Approve SKU"
        approveHandler={handleSaveApproval}
        selectedSkuName={formFieldsSku?.skuShortDescription}
        requestType="New SKU"
        isLoading={approveSKULoading}
        setFileBackendError={setFileBackendError}
        fileBackendError={fileBackendError}
      />
      <RejectSkuModal
        show={showSkuRejectModal}
        setShow={setShowSkuRejectModal}
        rejectHandler={handleRejectHandler}
        selectedSkuName={formFieldsSku?.skuShortDescription}
        selectedSku={skuID}
        requestType="New SKU"
        apiErrorMessage={rejectReasonApiError}
        onClearApiError={clearRejectModalError}
      />
    </>
  );
};

export default BMOSkuApproval;
